import React from "react";
import DomainsContent from "../function-components/DomainsContent";

function Domains({bannerimg}) {
  return (
    <>
      <DomainsContent bannerimg={bannerimg}/>
    </>
  );
}

export default Domains;
